import * as React from 'react';
import { SVGProps } from 'react';

const IconWellPipeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 2h3v20H8V6H7V2ZM16 22V6h1V2h-3v20h2Z" />
  </svg>
);
export default IconWellPipeSizeM;
